<small
  *ngIf="formCtrl.errors?.max && (formCtrl.dirty || formCtrl.touched)"
  class="p-invalid"
>
  {{ errorMsg }}
</small>
